module.exports = __webpack_public_path__ + "img/companyIntro34.155b24bd.png";